module.exports = __webpack_public_path__ + "static/img/accountbg.4b28a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/accountbg.png
// module id = Woyt
// module chunks = 22